const DEFAULT_BONUS_CALCULATOR_PARAMS = {
    minSumTravel: 6000,
    maxSumTravel: 200000,
    minSumOther: 6000,
    maxSumOther: 200000,
    maxBonus: 5000,
    prefMonthsNum: 2,
    prefTravelBonusRate: 0.015,
    prefRestBonusRate: 0.01,
    travelBonusRate: 0.015,
    restBonusRate: 0.01,
};
const MONTHS_IN_YEAR = 12;
export const getBonus = (params, bonusTravelValue, bonusOtherValue) => {
    const { maxBonus = 5000, prefMonthsNum = DEFAULT_BONUS_CALCULATOR_PARAMS.prefMonthsNum, prefTravelBonusRate = DEFAULT_BONUS_CALCULATOR_PARAMS.prefTravelBonusRate, prefRestBonusRate = 0.01, travelBonusRate = 0.015, restBonusRate = 0.01, } = params;
    const prefBonus = Math.min(Math.round(prefTravelBonusRate * bonusTravelValue) +
        Math.round(prefRestBonusRate * bonusOtherValue), maxBonus);
    const bonus = Math.min(Math.round(travelBonusRate * bonusTravelValue) + Math.round(restBonusRate * bonusOtherValue), maxBonus);
    const yearBonus = prefBonus * prefMonthsNum + bonus * (MONTHS_IN_YEAR - prefMonthsNum);
    return [prefBonus, yearBonus];
};
//# sourceMappingURL=getBonus.js.map